// @ts-nocheck
import React from 'react';

import { DownloadSubHeaderStyled } from './downloadSubHeader.style';

type Field = {
  name: string;
  value: string | number;
};

type Props = {
  fields: Field[];
  title: string;
};

function DownloadSubHeaderBase({ fields, title }: Props) {
  return (
    <DownloadSubHeaderStyled className="reportingSubHeader">
      <div className="reportingSubHeader__title">{title}</div>
      <div className="reportingSubHeader__items">
        {fields.map(field => (
          <div className="item" key={field.name}>
            <div className="item item--name">{field.name}</div>
            <div className="item item--value">{field.value}</div>
          </div>
        ))}
      </div>
    </DownloadSubHeaderStyled>
  );
}

export default DownloadSubHeaderBase;
